import OfferingSession from './OfferingSession';

const SelectOfferingSession = ({
  selectedOfferingSessions,
  setSelectedOfferingSessions,
  offeringSessionId,
  offeringId
}) => {
  const isSelected = selectedOfferingSessions.includes(offeringSessionId);

  const handleSelect = () => {
    setSelectedOfferingSessions((prev) => {
      if (prev.includes(offeringSessionId)) {
        return prev.filter((id) => id !== offeringSessionId);
      }
      return [...prev, offeringSessionId];
    });
  };

  return (
    <OfferingSession
      offeringId={offeringId}
      offeringSessionId={offeringSessionId}
      isSelected={isSelected}
      onSelect={handleSelect}
    />
  );
};

export default SelectOfferingSession;
